import { Controller, useFormContext } from 'react-hook-form'

import { WorkDay } from '@/entities/schedules/models/WorkDay'
import { WorkingHoursField } from '@/shared/components/WorkingHoursField/WorkingHoursField'
import { Grid } from '@mui/material'


type WorkingHoursTabProps = {
  isReadOnly: boolean
}

export const WorkingHoursTab: React.FC<WorkingHoursTabProps> = ({
  isReadOnly,
}) => {
  const { control } = useFormContext()

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Controller
          name="workHours.workDays"
          control={control}
          rules={{
            validate: (workDays: WorkDay[]) => {
              // Validate each workday has required fields
              for (const workDay of workDays) {
                if (!workDay.startTimeEarliest.trim()) {
                  return 'Start time earliest is required for all weekdays'
                }
              }

              return true
            },
          }}
          render={({ field: controlField, fieldState }) => {
            const { ref, ...rest } = controlField

            return (
              <WorkingHoursField
                {...rest}
                onChange={value => {
                  controlField.onChange(value)
                  controlField.onBlur()
                }}
                disabled={isReadOnly}
                error={!!fieldState.error}
              />
            )
          }}
        />
      </Grid>
    </Grid>
  )
}
